export enum MatchingStatus {
  Matching = "matching",
  Prefiltering = "prefiltering",
  MatchingAvailabilities = "matching_availabilities",
  Ready = "ready",
  MatchesOutdated = "matches_outdated",
  FiltersOutdated = "filters_outdated",
  AvailabilityOutdated = "availability_outdated",
  ActivityClosed = "activity_closed",
  ActivityNotSynchronized = "activity_not_synchronized"
}
